import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UseModal } from "../../hooks/UseModal";
import { addClabeInterbancaria_request, getClabeInterbancaria_request } from "../../services/metodosPago_services";
import { getEstado_request, getLocalidad_request } from "../../services/expediente_service";
import { validateRFC } from "../../utils/utils";
import { Stack } from "@mui/material";
import NewNavbar from "../../componentes/GeneralComponents/Navbar_Nuevo";
import { Content } from "antd/es/layout/layout";
import { Loader } from "../../componentes/GeneralComponents/Loader";
import { Button, Empty, Row, Select } from "antd";
import CuentasCard from "../../componentes/Metodos-Pagos/cuentasCard";
import Modalagregar from "../../componentes/GeneralComponents/ModalDetalle";
import { Add, AddCircle, Close } from "@mui/icons-material";
import LoaderModals from "../../componentes/GeneralComponents/Loader_modals";
import Campos from "../../componentes/GeneralComponents/campos";
import InputAntd from "../../componentes/GeneralComponents/InputAntd";
import InputFileSingle from "../../componentes/GeneralComponents/InputFileSingle";
import { Boton } from "../../componentes/GeneralComponents/Formularios";
import SelectAntd from "../../componentes/GeneralComponents/SelectAntd";
import InputDate from "../../componentes/GeneralComponents/InputDate";
import { SnackbarProvider } from "notistack";
import SnackBar from "../../componentes/GeneralComponents/Snackbar";
import "../styles/Cuenta-pagos.scss";

export default function CuentaPagos() {
    const dispatch = useDispatch();

    const infoUser = useSelector((state) => state.userInfo.usuario);

    const styleAñadirC = {
        height: "clac(100vh - 52px)",
        width: "clac(100vw - 52px)",
        margin: "0 2%",
    };

    const [isOpenAñadirC, OpenAñadirC, CloseAñadirC] = UseModal(false);

    const [CuentasList, setCuentasList] = useState([]);
    const [EstadosList, setEstadosList] = useState([]);
    const [LocalidadesList, setLocalidadesList] = useState([]);

    // FORM CLABE INTERBANCARIA
    const [Estado, setEstado] = useState(null);
    const [Localidad, setLocalidad] = useState(null);
    const [DireccionUno, setDireccionUno] = useState("");
    const [DireccionDos, setDireccionDos] = useState("");
    const [Cp, setCp] = useState("");
    const [Nacimiento, setNacimiento] = useState("");
    const [Genero, setGenero] = useState(null);
    const [Rfc, setRfc] = useState("");
    const [Telefono, setTelefono] = useState("");
    const [CredencialFileFront, setCredencialFileFront] = useState({
        name: "",
        url: "",
        file: "",
        size: 0,
        formato: "",
    });
    const [CredencialFileBack, setCredencialFileBack] = useState({
        name: "",
        url: "",
        file: "",
        size: 0,
        formato: "",
    });
    const [Url, setUrl] = useState("");
    const [NombreTitular, setNombreTitular] = useState("");
    const [ApellidosTitular, setApellidosTitular] = useState("");
    const [Clabe, setClabe] = useState("");

    // MANEJA DE MENSAJES
    const [open, setOpen] = useState(false);
    const [typeMessage, setTypeMessage] = useState("");
    const [message, setMessage] = useState("");

    const [MensajeEstado, setMensajeEstado] = useState("true");
    const [MensajeLocalidad, setMensajeLocalidad] = useState("true");
    const [MensajeDireccionUno, setMensajeDireccionUno] = useState("true");
    const [MensajeDireccionDos, setMensajeDireccionDos] = useState("true");
    const [MensajeCp, setMensajeCp] = useState("true");
    const [MensajeNacimiento, setMensajeNacimiento] = useState("true");
    const [MensajeGenero, setMensajeGenero] = useState("true");
    const [MensajeRfc, setMensajeRfc] = useState("true");
    const [MensajeTelefono, setMensajeTelefono] = useState("true");
    const [MensajeCredencialFront, setMensajeCredencialFront] = useState("true");
    const [MensajeCredencialBack, setMensajeCredencialBack] = useState("true");
    const [MensajeUrl, setMensajeUrl] = useState("true");
    const [MensajeClabe, setMensajeClabe] = useState("true");
    const [MensajeNombreTitular, setMensajeNombreTitular] = useState("true");
    const [MensajeApellidosTitular, setMensajeApellidosTitular] =
        useState("true");

    const [loader, setLoader] = useState(false);
    const [loaderModal, setLoaderModal] = useState(false);

    async function getCuentas() {
        setLoader(true);
        let response = await getClabeInterbancaria_request();
        if (response.ok) {
            console.log(response.data);
            setCuentasList(response.data);
        } else {
            setOpen(true);
            setTypeMessage("error");
            setMessage(response.mensaje);
        }
        setLoader(false);
        return;
    }

    const validateData = () => {
        if (!validateRFC(Rfc)) {
            setMensajeRfc("false");
            return false;
        }
        if (Telefono.length !== 10) {
            setMensajeTelefono("false");
            return false;
        }
        if (Clabe.length !== 18) {
            setMensajeClabe("false");
            return false;
        }

        return true;
    }

    async function saveClabeInterbancaria(e) {
        setLoaderModal(true);
        if (
            !!Estado &&
            !!Localidad &&
            !!DireccionUno &&
            !!Cp &&
            !!Nacimiento &&
            !!Genero &&
            !!Rfc &&
            !!Telefono &&
            !!CredencialFileFront.file &&
            !!CredencialFileBack.file &&
            !!Clabe && !!NombreTitular && !!ApellidosTitular &&
            MensajeEstado !== "false" &&
            MensajeLocalidad !== "false" &&
            MensajeDireccionUno !== "false" &&
            MensajeDireccionDos !== "false" &&
            MensajeCp !== "false" &&
            MensajeNacimiento !== "false" &&
            MensajeGenero !== "false" &&
            MensajeRfc !== "false" &&
            MensajeTelefono !== "false" &&
            MensajeCredencialFront !== "false" &&
            MensajeCredencialBack !== "false" &&
            MensajeNombreTitular !== "false" && MensajeApellidosTitular !== "false"
        ) {

            if (!validateData()) {
                setLoaderModal(false);
                return;
            }

            let data = new FormData();
            let array_fecha = Nacimiento.split("/");

            let dia = array_fecha[0];
            let mes = array_fecha[1];
            let year = array_fecha[2];

            data.append("Ciudad", Estado);
            data.append("Estado", Localidad);
            data.append("Direccion1", DireccionUno);
            data.append("Direccion2", DireccionDos);
            data.append("PostalCode", Cp);
            data.append("Dia", dia);
            data.append("Mes", mes);
            data.append("Año", year);
            data.append("genero", Genero);
            data.append("RFC", Rfc);
            data.append("telefono", Telefono);
            data.append("front", CredencialFileFront.file, CredencialFileFront.name);
            data.append("back", CredencialFileBack.file, CredencialFileBack.name);
            data.append("CLABE", Clabe);
            data.append("nombre", NombreTitular);
            data.append("apellidos", ApellidosTitular);

            let response = await addClabeInterbancaria_request(data);
            if (response.ok) {
                setOpen(true);
                setTypeMessage("success");
                setMessage("Cuenta agregada");
                getCuentas();
                setEstado(null);
                setLocalidad(null);
                setDireccionUno("");
                setDireccionDos("");
                setCp("");
                setGenero(null);
                setRfc("");
                setTelefono("");
                setCredencialFileFront({ name: "", url: "", file: "" });
                setCredencialFileBack({ name: "", url: "", file: "" });
                setUrl("");
                setClabe("");
                CloseAñadirC(true);
            } else {
                setOpen(true);
                setTypeMessage("error");
                setMessage(response.mensaje);
            }
        } else {
            if (!!!Estado) {
                setMensajeEstado("false");
            }
            if (!!!Localidad) {
                setMensajeLocalidad("false");
            }
            if (!!!DireccionUno) {
                setMensajeDireccionUno("false");
            }

            if (!!!Cp) {
                setMensajeCp("false");
            }
            if (!!!Nacimiento) {
                setMensajeNacimiento("false");
            }
            if (!!!Genero) {
                setMensajeGenero("false");
            }
            if (!!!Rfc) {
                setMensajeRfc("false");
            }
            if (!!!Telefono) {
                setMensajeTelefono("false");
            }
            if (!CredencialFileFront.file) {
                setMensajeCredencialFront("false");
            }
            if (!CredencialFileBack.file) {
                setMensajeCredencialBack("false");
            }

            if (!!!Clabe) {
                setMensajeClabe("false");
            }

            if (!NombreTitular) {
                setMensajeNombreTitular("false");
            }

            if (!ApellidosTitular) {
                setMensajeApellidosTitular("false");
            }

            setOpen(true);
            setTypeMessage("warning");
            setMessage("Faltan campos por completar");
        }
        setLoaderModal(false);
        return;
    }

    async function getEstados() {
        let response = await getEstado_request();
        if (response.ok) {
            // console.log(response.data);
            let estados_temp = []
            response.data.forEach(estado => {
                estados_temp.push({ value: estado.id.toString(), label: estado.Estado });
            });
            setEstadosList(estados_temp);
        } else {
            setEstadosList([]);
        }
    }

    async function getLocalidades(estado) {
        let response = await getLocalidad_request(estado);
        if (response.ok) {
            // console.log(response.data);
            let localidades_temp = []
            response.data.forEach(estado => {
                localidades_temp.push({ value: estado, label: estado });
            });
            setLocalidadesList(localidades_temp);
        } else {
            setLocalidadesList([]);
        }
    }

    function filterOptions(input, option) {
        var chars = {
            á: "a",
            é: "e",
            í: "i",
            ó: "o",
            ú: "u",
            à: "a",
            è: "e",
            ì: "i",
            ò: "o",
            ù: "u",
            ñ: "n",
            Á: "A",
            É: "E",
            Í: "I",
            Ó: "O",
            Ú: "U",
            À: "A",
            È: "E",
            Ì: "I",
            Ò: "O",
            Ù: "U",
            Ñ: "N",
        };
        var expr = /[áàéèíìóòúùñ]/gi;
        return (
            option?.label
                .replace(expr, function (e) {
                    return chars[e];
                })
                .toLowerCase()
                .indexOf(
                    input
                        .replace(expr, function (e) {
                            return chars[e];
                        })
                        .toLowerCase()
                ) > -1
        );
    }

    function filterSort(optionA, optionB) {
        var chars = {
            á: "a",
            é: "e",
            í: "i",
            ó: "o",
            ú: "u",
            à: "a",
            è: "e",
            ì: "i",
            ò: "o",
            ù: "u",
            ñ: "n",
            Á: "A",
            É: "E",
            Í: "I",
            Ó: "O",
            Ú: "U",
            À: "A",
            È: "E",
            Ì: "I",
            Ò: "O",
            Ù: "U",
            Ñ: "N",
        };
        var expr = /[áàéèíìóòúùñ]/gi;
        return (
            optionA?.label
                .replace(expr, function (e) {
                    return chars[e];
                })
                .toLowerCase() ?? ""
        )
            .replace(expr, function (e) {
                return chars[e];
            })
            .toLowerCase()
            .localeCompare(
                (
                    optionB?.label
                        .replace(expr, function (e) {
                            return chars[e];
                        })
                        .toLowerCase() ?? ""
                )
                    .replace(expr, function (e) {
                        return chars[e];
                    })
                    .toLowerCase()
            );
    }

    useEffect(() => {
        getCuentas();
        getEstados();
        return;
    }, []);

    return (
        <Stack>
            <NewNavbar
                showBanner={false}
                mensajesError={{
                    setOpen: setOpen,
                    setTypeMessage: setTypeMessage,
                    setMessage: setMessage,
                }}
                modulo={"CunetaPagos"}
                searchBar={
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "1% 3% ",
                            margin: "5px 0",
                            alignItems: "center",
                            background: "#fff"
                        }}
                    >
                        <div style={{ color: "#424242" }}>
                            <h3>Cuenta para recepción de ingresos</h3>
                            {/* <span>Cuenta para recibir pagos de pacientes Ygia</span> */}
                        </div>
                        {CuentasList.length>0 ? (
                            <div></div>
                        ) : (
                            <Button className="roundedButtonBlue" onClick={OpenAñadirC}>
                                <Row style={{ gap: ".5rem", width: "100%", color: "white", justifyContent: "center", alignItems: "center" }}>
                                    Nuevo
                                    <AddCircle/>
                                </Row>
                            </Button>
                        )}
                    </div>
                }
            />

            <Content
                className="site-layout"
                style={{
                    padding: "0 3%",
                    width: "100%",
                    overflow: "initial",
                }}
            >
                {loader ? (
                    <Loader />
                ) : (
                    <div>
                        {CuentasList.length === 0 ? (
                            <Empty
                                description={
                                    <span style={{ color: "black" }}>Sin cuentas</span>
                                }
                            />
                        ) : (
                            <CuentasCard cuentas={CuentasList} />
                        )}
                    </div>
                )}
            </Content>

            {/* AGREGAR CLABE INTERBANCARIA */}
            <Modalagregar
                styleDet={styleAñadirC}
                isOpen={isOpenAñadirC}
                closeModal={CloseAñadirC}
            >
                <div className="Topmodaldetalle">
                    <p>Cuenta nueva</p>

                    <Close style={{ fontSize: 20, cursor: "pointer" }} onClick={CloseAñadirC} />
                </div>
                <div className="contenidomodal">
                    {loaderModal ? (
                        <LoaderModals />
                    ) : (
                        <form action="" style={{ padding: "0" }}>
                            <div style={{ padding: "1% 2%" }}>
                                <Campos
                                    label="Estado:"
                                    textError="Debe seleccionar un estado"
                                    valueError={MensajeEstado}
                                >
                                    <Select
                                        showSearch
                                        style={{
                                            width: "100%",
                                            margin: ".5% 0",
                                        }}
                                        placeholder="Estado"
                                        optionFilterProp="children"
                                        filterOption={filterOptions}
                                        filterSort={filterSort}
                                        value={Estado}
                                        onSelect={(e) => {
                                            setEstado(e);
                                            getLocalidades(e);
                                            setMensajeEstado("true");
                                        }}
                                        options={EstadosList}
                                    />
                                </Campos>

                                <Campos
                                    label="Localidad:"
                                    textError="Debe seleccionar una localidad"
                                    valueError={MensajeLocalidad}
                                >
                                    <Select
                                        showSearch
                                        style={{
                                            width: "100%",
                                            margin: ".5% 0",
                                        }}
                                        placeholder="Localidad"
                                        optionFilterProp="children"
                                        filterOption={filterOptions}
                                        filterSort={filterSort}
                                        value={Localidad}
                                        onSelect={(e) => {
                                            setLocalidad(e);
                                            setMensajeLocalidad("true");
                                        }}
                                        options={LocalidadesList}
                                        disabled={LocalidadesList.length === 0 ? true : false}
                                    />
                                </Campos>

                                <InputAntd
                                    label="Direccion 1:"
                                    type=""
                                    placeholder="Escriba una dirección"
                                    value={DireccionUno}
                                    setStateValue={setDireccionUno}
                                    vacio={false}
                                    setStateError={setMensajeDireccionUno}
                                    textError={["Debe escribir una dirección", ""]}
                                    valueError={MensajeDireccionUno}
                                    styleDiv={{ width: "100%" }}
                                />

                                <InputAntd
                                    label="Direccion 2:"
                                    type=""
                                    placeholder="Escriba una dirección"
                                    value={DireccionDos}
                                    setStateValue={setDireccionDos}
                                    vacio={false}
                                    setStateError={setMensajeDireccionDos}
                                    textError={["Debe escribir una dirección", ""]}
                                    valueError={MensajeDireccionDos}
                                    styleDiv={{ width: "100%" }}
                                />

                                <InputAntd
                                    label="Codigo postal:"
                                    type=""
                                    placeholder="Escriba un código postal"
                                    value={Cp}
                                    setStateValue={setCp}
                                    vacio={false}
                                    setStateError={setMensajeCp}
                                    textError={["Debe escribir un código postal", ""]}
                                    valueError={MensajeCp}
                                    styleDiv={{ width: "100%" }}
                                    maxLength={10}
                                />

                                <InputDate
                                    label="Fecha de nacimiento:"
                                    requiredICon={true}
                                    placeholder="DD/MM/AAAA"
                                    style={{ width: "100%", background: "white" }}
                                    value={!!Nacimiento ? Nacimiento : ""}
                                    setStateValue={setNacimiento}
                                    styleDiv={{ width: "100%" }}
                                    setStateError={setMensajeNacimiento}
                                    valueError={MensajeNacimiento}
                                    textError={["Debe elegir una fecha de nacimiento", "Fecha no válida"]}
                                    vacio={false}
                                />

                                <SelectAntd
                                    label="Género:"
                                    value={Genero}
                                    style={{ width: "100%" }}
                                    placeholder="Género"
                                    options={[
                                        { value: "female", label: "Femenino" },
                                        { value: "male", label: "Masculino" },
                                    ]}
                                    setStateValue={setGenero}
                                    styleDiv={{ width: "100%" }}
                                    setStateError={setMensajeGenero}
                                    valueError={MensajeGenero}
                                    textError={"Debe seleccionar un género"}
                                />

                                <InputAntd
                                    label="RFC:"
                                    type=""
                                    placeholder="Escriba un rfc"
                                    value={Rfc.toLocaleUpperCase()}
                                    setStateValue={setRfc}
                                    vacio={false}
                                    setStateError={setMensajeRfc}
                                    textError={["Debe escribir un rfc valido", ""]}
                                    valueError={MensajeRfc}
                                    styleDiv={{ width: "100%" }}
                                />

                                <InputAntd
                                    label="Télefono:"
                                    type=""
                                    placeholder="Escriba una télefono"
                                    value={Telefono}
                                    setStateValue={setTelefono}
                                    vacio={false}
                                    setStateError={setMensajeTelefono}
                                    maxLength={10}
                                    textError={["Debe escribir una télefono", ""]}
                                    valueError={MensajeTelefono}
                                    styleDiv={{ width: "100%" }}
                                />

                                <Campos
                                    label="* Frente de credencial de elector"
                                    textError="Debe adjuntar una imagen del frente de su credencial"
                                    valueError={MensajeCredencialFront}
                                >
                                    <InputFileSingle
                                        id="front"
                                        archivoValue={CredencialFileFront}
                                        texto={"Ajuntar"}
                                        archivo={setCredencialFileFront}
                                        formatos={4}
                                        extras={[
                                            setOpen,
                                            setTypeMessage,
                                            setMessage,
                                            setMensajeCredencialFront,
                                        ]}
                                    />
                                </Campos>

                                <Campos
                                    label="* Reverso de credencial de elector"
                                    textError="Debe adjuntar una imagen del reverso de su credencial de elector"
                                    valueError={MensajeCredencialBack}
                                >
                                    <InputFileSingle
                                        id="back"
                                        archivoValue={CredencialFileBack}
                                        texto={"Ajuntar"}
                                        archivo={setCredencialFileBack}
                                        formatos={4}
                                        extras={[
                                            setOpen,
                                            setTypeMessage,
                                            setMessage,
                                            setMensajeCredencialBack,
                                        ]}
                                    />
                                </Campos>

                                <InputAntd
                                    label="Nombre del titular:"
                                    type=""
                                    placeholder="Escriba su nombre"
                                    value={NombreTitular}
                                    setStateValue={setNombreTitular}
                                    vacio={true}
                                    setStateError={setMensajeNombreTitular}
                                    textError={["Debe escribir un nombre", ""]}
                                    valueError={MensajeNombreTitular}
                                    styleDiv={{ width: "100%" }}
                                />

                                <InputAntd
                                    label="Apellidos del titular:"
                                    type=""
                                    placeholder="Escriba sus apellidos"
                                    value={ApellidosTitular}
                                    setStateValue={setApellidosTitular}
                                    vacio={true}
                                    setStateError={setMensajeApellidosTitular}
                                    textError={["Debe escribir un apellido", ""]}
                                    valueError={MensajeApellidosTitular}
                                    styleDiv={{ width: "100%" }}
                                />

                                <InputAntd
                                    label="CLABE interbancaria:"
                                    type=""
                                    placeholder="Escriba una CLABE interbancaria"
                                    value={Clabe}
                                    setStateValue={setClabe}
                                    vacio={false}
                                    maxLength={18}
                                    setStateError={setMensajeClabe}
                                    textError={["Debe escribir una CLABE interbancaria", ""]}
                                    valueError={MensajeClabe}
                                    styleDiv={{ width: "100%" }}
                                />

                                <Row style={{ display: "flex", justifyContent: "center", alignItems: "center", margin: "10px 0" }}>
                                    <Boton
                                        onClick={() => {
                                            saveClabeInterbancaria();
                                        }}
                                        type="button"
                                        style={{
                                            width: "100%",
                                            height: "30px",
                                            backgroundColor: "#148f9f",
                                            color: "white",
                                        }}
                                    >
                                        Añadir
                                    </Boton>
                                </Row>
                            </div>
                        </form>
                    )}
                </div>
            </Modalagregar>

            <SnackbarProvider maxSnack={3}>
                <SnackBar
                    setOpen={setOpen}
                    open={open}
                    typeMessage={typeMessage}
                    message={message}
                />
            </SnackbarProvider>
        </Stack>
    );
}